<template>
	<div class="page">
		<div class="background">
		</div>
		<div class="content">
			<Row type="flex" justify="center" align="middle" style="height: 100vh">
				<Col span="4"></Col>
				<Col span="16">
					<Card class="myCard" :bordered="false" style="height: 65vh;border-radius:15px;">
						<Row style="height:65vh;" type="flex" align="middle">
							<Col span="12">
								<img style="width:100%;height:100%;" src="https://yljx-oss.irematch.com/PicGo/loginBgsorting.png"
								     alt="">
							</Col>
							<Col style="padding:20px; padding-left:50px; box-sizing:border-box;" span="12">
								<p class="projectTitle">欢迎登录悦邻分拣系统</p>
								<p class="descText">用技术创新为生鲜行业降本增效</p>
								<Form style="width:100%;" ref="formInline" :model="loginForm" :rules="loginFormRules"
								      @keydown.enter.native="loginSubmit">
									<FormItem prop="platformId">
										<Input class="myInput" v-model="loginForm.platformId" placeholder="请输入平台标识" size="large">
											<!-- <Icon :size="28" type="ios-key-outline" slot="prepend"></Icon> -->
										</Input>
									</FormItem>
									<FormItem prop="username">
										<Input class="myInput" v-model="loginForm.username" placeholder="请输入登录账号" size="large">
											<!-- <Icon :size="28" type="ios-person-outline" slot="prepend"></Icon> -->
										</Input>
									</FormItem>
									<FormItem prop="password">
										<Input class="myInput" type="password" password v-model="loginForm.password" placeholder="请输入登录密码"
										       size="large">
											<!-- <Icon :size="28" type="ios-lock-outline" slot="prepend"></Icon> -->
										</Input>
									</FormItem>
									<FormItem>
										<RadioGroup v-model="loginForm.loginRole" @on-change="changeLoginRoleCallback">
											<Radio label="1"><span>总站</span></Radio>
											<Radio label="20"><span>供应商</span></Radio>
										</RadioGroup>
									</FormItem>
									<FormItem>
										<Button type="success" long size="large" @click="loginSubmit">登录</Button>
									</FormItem>
								</Form>
							</Col>
						</Row>
						<img class="qiuqiuone" src="https://yljx-oss.irematch.com/PicGo/qiuqiu.png" alt="">
						<img class="qiuqiutwo" src="https://yljx-oss.irematch.com/PicGo/qiuqiu.png" alt="">
					</Card>
				</Col>
				<Col span="4"></Col>
			</Row>
		</div>
	</div>
</template>

<script>
	const usernameReg = (rule, value, callback) => {
		// eslint-disable-next-line
		let regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
		let regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im
		// // console.log(value)
		if (value === '') {
			callback(new Error('用户名不能为空'))
		} else {
			if (regEn.test(value) || regCn.test(value)) {
				callback(new Error('用户名含有特殊字符'))
			} else {
				callback()
			}
		}
	};
	import {sortingLogin, getTokenByCode} from '@/api/user/user'
	import {setToken} from '@/libs/util'
	import {mapActions} from "vuex";

	export default {
		name: 'login',
		data() {
			return {
				// 登录数据
				loginForm: {
					platformId: '',
					username: '',
					password: '',
					loginRole: "1"
				},
				loginFormRules: {
					platformId: [{required: true, message: '平台标识不能为空', trigger: 'change'}],
					username: [{required: true, validator: usernameReg, trigger: 'change'}],
					password: [{required: true, message: '密码不能为空', trigger: 'change'}]
				},
			}
		},
		methods: {
			...mapActions(["getUserInfo"]),
			async loginSubmit() {
				let bool = await this.$refs['formInline'].validate();
				if (!bool) {
					return this.$Notice.error({title: '请输入登录信息',})
				}
				return new Promise((resolve, reject) => {
					sortingLogin(this.loginForm).then(data => {
						if (data.data.code != 1200) {
							this.$Message.error(data.data.msg);
						} else {
							let cond = {
								authorization: data.data.data.token,
								client_id: data.data.data.client_id,
								redirect_uri: data.data.data.redirect_uri,
							};
							localStorage.setItem("currentPlatformId", this.loginForm.platformId);
							this.getTokenByCode(cond);
						}
					}).catch(err => {
						this.$Message.error(err);
					});
				});
			},
			// 修改登录身份
			changeLoginRoleCallback(event) {
				localStorage.setItem("sortingloginRole", event);
			},
			// 获取token
			getTokenByCode(cond) {
				return new Promise((resolve, reject) => {
					getTokenByCode(cond).then(res => {
						if (res.status === 200) {
							// 设置用户的信息
							this.$store.state.user.token = res.data.data.accessToken;
							setToken(res.data.data.accessToken);
							this.getUserInfo().then(res => {
								this.$router.push({name: this.$config.homeName});
								this.$store.dispatch("initChromeApp");
								this.$store.dispatch("initAllSkuCover");
								this.$store.dispatch("initAllSupplier");
								this.$store.dispatch("initPage");
								this.$store.dispatch("getDeliverySetting");
								this.$store.dispatch("queryTurnoverBoxList");
								// this.$store.dispatch("queryOperationList");
							})
						} else {
							setToken("");
							this.$Notice.error({title: res.msg, duration: 2});
						}
					});
				}).catch(err => {
					console.log(err);
					this.$Message.error(err);
				});
			},
		},
		mounted() {
			if (this.$route.params.platformId) {
				this.loginForm.platformId = this.$route.params.platformId;
			} else {
				if (localStorage.getItem("currentPlatformId")) {
					// console.log(localStorage.getItem("currentPlatformId"))
					this.loginForm.platformId = localStorage.getItem("currentPlatformId");
				}
			}
			if (localStorage.getItem("sortingloginRole")) {
				this.loginForm.loginRole = localStorage.getItem("sortingloginRole");
			}
		}
	}
</script>

<style scoped lang="less">
	.page {
		width: 100%;
		height: 100%;

		.background {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background-image: url('https://yljx-oss.irematch.com/yinghe-webside/yinghewebsite.jpg');
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
			filter: blur(6px);
		}

		.projectTitle {
			font-size: 26px;
			color: #19be6b;
			font-weight: 800;
			margin-bottom: 14px;
		}

		.descText {
			font-size: 16px;
			color: #333;
			margin-bottom: 10px;
		}

		.content {
			position: relative;
			z-index: 2
		}

		.myCard {
			position: relative;

			.qiuqiuone {
				width: 60px;
				height: 60px;
				position: absolute;
				top: 20px;
				right: 40px;
			}

			.qiuqiutwo {
				width: 60px;
				height: 60px;
				position: absolute;
				bottom: 20px;
				left: 40px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue